<template>
  <el-dialog title="设置" :visible.sync="dialogFormVisible" append-to-body>
    <el-form :model="form" label-width="100px">
      <el-form-item label="查询层级">
        <el-input-number :min="0" step="1" v-model="form.queryHierarchy" autocomplete="off"></el-input-number>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {setHierarchy} from '@/api/storeClass'
export default {
  data() {
    return {
      dialogFormVisible: false,
      form:{
        id:'',
        queryHierarchy:''
      }
    }
  },
  components: {},
  props: {},
  created() {
  },
  mounted() {
  },
  methods: {
    openDialog(data) {
      this.form.id = data.id
      this.form.queryHierarchy = data.queryHierarchy
      this.dialogFormVisible = true
    },
    save(){
      let params = {
        id:this.form.id,
        num:this.form.queryHierarchy
      }
      setHierarchy(params).then(res=>{
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.$emit('getList')
        this.dialogFormVisible = false
      })
    }
  }
}
</script>
<style scoped>

</style>
